<template>
  <responsive-drawer-header :color="color" :headerBg="theme.appBar.other.bg" noDrawerPushContent>
    <template v-slot:drawer-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:drawer-subtitle>{{ $t('ud.navigationTitle') }}</template>

    <!-- left container -->
    <template v-slot:left-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:left-subtitle v-if="dataLoaded">
      {{ $t(activeConfig.navigationTitle) }}
    </template>

    <template v-slot:right>
      <confirmation-dialog
        headerProp="search.closeDialog"
        textProp="close.confirmation"
        :open="closeDialogOpen"
        @close="$store.commit('unfalldesk/toggleCloseDialog', false)"
        @click="onCloseClick"
      >
        <template v-if="!xs" v-slot:activator="{ on }">
          <v-btn :color="theme.appBar.other.color" icon v-on="on">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </template>
      </confirmation-dialog>
      <v-dialog v-model="trayDialog" max-width="500px">
        <template v-if="!xs" v-slot:activator="{ on, attrs }">
          <v-badge color="green" :content="tray.length + ''" offset-y="10" offset-x="20">
            <v-btn v-on="on" :color="theme.appBar.other.color" v-bind="attrs" dense dark text>{{ $t('tray') }}</v-btn>
          </v-badge>
        </template>
        <v-card>
          <v-card-title class="text">
            {{ $t('tray') }}
          </v-card-title>
          <v-card-text>
            <v-row v-for="item in tray" :key="item.created">
              <v-col :cols="xs ? 10 : 11" class="pa-0">
                <v-list-item :disabled="item.created === trayDate" @click="openTray(item)">
                  <span v-if="item.sent">{{ $t('udConfig.tray.sent') }}&nbsp;</span>
                  {{ $t('udConfig.tray.open', { date: formatAsLocaleDateTime(new Date(item.created)) }) }}
                </v-list-item>
              </v-col>
              <v-col :cols="xs ? 2 : 1" style="align-self: center" class="pa-0">
                <v-btn v-if="!item.sent" small icon color="error" :disabled="item.created === trayDate" @click="removeTrayItem(item)">
                  <v-icon>mdi-delete-circle</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <div v-if="tray.length === 0">{{ $t('empty') }}</div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-menu v-if="xs" style="min-width: 250px" left bottom close transition="slide-y-transition" offset-y dense close-on-click close-on-content-click>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="xs" x-small :color="color" fab class="d-flex" icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <div style="background-color: #fff">
          <v-list-item ripple>
            <v-list-item-content class="cursor-pointer" @click="trayDialog = true">
              {{ $t('tray') }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item ripple>
            <v-list-item-content class="cursor-pointer" @click="onCloseClick">
              {{ $t('search.closeDialog') }}
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-menu>
    </template>
  </responsive-drawer-header>
</template>

<script>
import { mapState } from 'vuex';
import ResponsiveDrawerHeader from '@/layouts/ResponsiveDrawerHeader.vue';
import ConfirmationDialog from '@/dialogs/ConfirmationDialog.vue';
import common from '@/mixins/common';
import configMixin from '../../mixins/configMixin';
import dateUtils from '@/common/dateUtils';
import { conditionFilter } from '../wagenbuch/wb-config/wb-common';

export default {
  name: 'UnfalldeskHeader',
  mixins: [common, configMixin],
  components: { ResponsiveDrawerHeader, ConfirmationDialog },
  data: () => ({ trayDialog: false, formatAsLocaleDateTime: dateUtils.formatAsLocaleDateTime }),
  computed: {
    ...mapState('unfalldesk', ['dataLoaded', 'closeDialogOpen', 'toRoute']),
    color() {
      return this.theme.appBar.other.color;
    },
    active: {
      get() {
        return this.$store.state.unfalldesk.active;
      },
      set(val) {
        this.$store.state.unfalldesk.active = val;
      },
    },
    activeItem: {
      get() {
        return this.$store.state.unfalldesk.activeItem;
      },
      set(val) {
        this.$store.state.unfalldesk.activeItem = val;
      },
    },
    input: {
      get() {
        return this.$store.state.unfalldesk.formInput;
      },
      set(val) {
        this.$store.state.unfalldesk.formInput = val;
      },
    },
    trayDate: {
      get() {
        return this.$store.state.unfalldesk.trayDate;
      },
      set(val) {
        this.$store.state.unfalldesk.trayDate = val;
      },
    },
    trayUuid: {
      get() {
        return this.$store.state.unfalldesk.trayUuid;
      },
      set(val) {
        this.$store.state.unfalldesk.trayUuid = val;
      },
    },
    dataLoaded: {
      get() {
        return this.$store.state.unfalldesk.dataLoaded;
      },
      set(val) {
        this.$store.state.unfalldesk.dataLoaded = val;
      },
    },
    tray: {
      get() {
        return this.$store.state.unfalldesk.tray;
      },
      set(val) {
        this.$store.commit('unfalldesk/setTray', val);
      },
    },
    activeConfig() {
      return this.$store.state.unfalldesk[this.active.name].filter((nav) => conditionFilter(this.input, nav))[this.active.index];
    },
  },
  methods: {
    onCloseClick() {
      this.trayDate = undefined;
      this.trayUuid = undefined;
      this.active = { name: 'udConfig', index: 0 };
      this.input = {};
      if (this.toRoute === undefined) {
        if (this.active.name === 'udConfig') {
          this.$router.push('/');
        }
      } else {
        this.$router.push(this.toRoute.path);
      }
      this.$store.commit('unfalldesk/toggleCloseDialog', false);
    },
    openTray(item) {
      this.trayDialog = false;
      this.dataLoaded = false;
      this.trayDate = item.created; //Set active so that other components know that a tray item has been loaded
      this.trayUuid = item.data.uuid;
      this.input = JSON.parse(JSON.stringify(item.data));
      this.active = item.active;
      setTimeout(() => {
        this.dataLoaded = true;
      }, 500); //Fix timing issues
    },
    removeTrayItem(item) {
      const tray = this.tray;
      const found = tray.find((i) => i.created === item.created);
      if (found !== undefined) {
        const index = tray.indexOf(found);
        tray.splice(index, 1);
        this.tray = tray; //Trigger local storage change
      }
    },
    cleanUpTray() {
      const moduleConfig = this.getModuleConfig('Unfalldesk', this.$route.params.instance);
      if (moduleConfig.keepInSendboxForDays) {
        this.tray.forEach((trayItem) => {
          if (trayItem.sent) {
            let dateSent = new Date(trayItem.sent);
            let editableUntil = new Date(dateSent.setDate(dateSent.getDate() + moduleConfig.keepInSendboxForDays));
            if (Date.now() > editableUntil) {
              console.debug('remove trayItem', trayItem);
              this.removeTrayItem(trayItem);
            }
          }
        });
      }
    },
  },
  mounted() {
    this.cleanUpTray();
  },
};
</script>
